export default "__VITE_PUBLIC_ASSET__448d4507__"